import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import WebFont from "webfontloader";
import Select from "react-select";

import { auth, db } from "../../../firebase";
import { doc, getDoc, updateDoc, setDoc } from "firebase/firestore";

import { useUser } from '../../../store/UserProvider';
import { saveUserLog } from '../LogandUtils'; // 경로에 맞게 수정
import customBackgroundByUser from '../../../store/customBackground'; // 임시

import SEO from '../../SEO';
import Popup from "../../mobile/Popup";
import Loading from "../../Loading";
import MyPageMenu from './MyPageMenu';
import CheckBoxSelector from "../CheckBoxSelector"
import MusicianGalleryPopup from './MusicianGalleryPopupNew';
import MusicardSourcePopup from "./MusicardSourcePopup";

import styleClasses from '../css/mobile/MyPage.module.scss';

function MusicardEditPage() {
  const { musicardID }  = useParams();

const { user, userLoading } = useUser();

  const navigate        = useNavigate();
  
  const location        = useLocation();

  const nameRef         = useRef();
  const colorInput      = useRef();
  const isSubmitting    = useRef(false);

  const [openMenu, setOpenMenu]                 = useState(false);
  const [userID, setUserID]                     = useState(null);
  const [musicard, setMusicard]                 = useState(null);
  const [nameError, setNameError]               = useState('');
  const [nameErrorText, setNameErrorText]       = useState('');
  const [loading, setLoading]                   = useState(true);
  const [error, setError]                       = useState("");
  const [genreOptions, setGenreOptions]         = useState([]);
  const [positionOptions, setPositionOptions]   = useState([]);

  const [openPopup, setOpenPopup]               = useState(false);
  const [popupTitle, setPopupTitle]             = useState('');
  const [popupText, setPopupText]               = useState(''); // 이 줄 추가
  const [popupButtonText, setPopupButtonText]   = useState('');
  const [customFunction, setCustomFunction]     = useState('');

  const [openGalleryPopup, setOpenGalleryPopup] = useState(false);
  const [popupFunction, setPopupFunction]       = useState('');
  const [menuImageSlots, setMenuImageSlots]     = useState([]);
  const [imageIndex, setImageIndex]             = useState(0);
  const [buttonLoading, setButtonLoading]       = useState(false);

  const [openSourcePopup, setOpenSourcePopup]                   = useState(false);
  const [hasUpdatedSource, setHasUpdatedSource] = useState(false);

  // 선택된 이미지 타입: "menu" (메뉴 이미지), "background", "profile", "cdThumbnail" 등
  const [selectedImageType, setSelectedImageType] = useState("");

  const [hasStyleData, setHasStyleData] = useState(false);

  const [formData, setFormData]                 = useState({
    name: "",
    genres: [],
    positions: [],
    profileImage: "",
    CDThumbnail: "",
    backgroundColor: "",
    fontcolor: "#FFFFFF",
    font: "", // <-- 폰트 선택 값 (URL 형식)
    dark: false, // 추가: 아이콘 색이 어둡게 선택되었는지 여부
    menuImages: [],
    sns: {},
    musicLinks: {}, // <-- 추가: 뮤직 링크 정보 저장
    videoId: "",
    videoTitle: "",
    qrimg: ""
  });
  
  // Google Fonts 목록을 저장할 상태
  const [fonts, setFonts] = useState([]);

  // Google Fonts API에서 폰트 목록 가져오기 (API 키 필요)
  useEffect(() => {
    const fetchFonts = async () => {
    try {
        const apiKey = "AIzaSyCIDe8t4O430G1ecwKIlzaKnDnpHdyu5og"; // 본인의 API 키로 교체하세요.
        const response = await fetch(`https://www.googleapis.com/webfonts/v1/webfonts?key=${apiKey}`);
        const data = await response.json();
        // data.items는 폰트 목록 배열입니다.
        // 각 폰트 객체의 subsets 배열에 'korean'이 포함되어 있는 폰트만 필터링
        const koreanFonts = data.items.filter(font => font.subsets.includes('korean'));
        setFonts(koreanFonts);
    } catch (error) {
        console.error("Error fetching fonts: ", error);
    }
    };
    fetchFonts();
  }, []);

  // 가져온 폰트 목록을 기반으로 WebFont Loader를 이용해 폰트 로드
  useEffect(() => {
    if (fonts.length > 0) {
      const families = fonts.map(font => font.family);
      WebFont.load({
        google: {
          families: families
        },
        active: () => {
          //console.log("All fonts loaded");
        }
      });
    }
  }, [fonts]);

  // react-select 옵션 데이터 생성: 각 옵션에 fontFamily 프로퍼티 추가
  const options = fonts.map(font => ({
    value: font.files?.regular, // 실제 사용할 폰트 파일 URL (또는 font.family 등 원하는 값)
    label: font.family,
    fontFamily: font.family,
  }));

  // react-select의 스타일 커스터마이징
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      fontFamily: state.data.fontFamily, // 옵션의 fontFamily 적용
    }),
    singleValue: (provided, state) => ({
      ...provided,
      fontFamily: state.data.fontFamily, // 선택된 값에 적용
    }),
  };

  // 🔹 메뉴 열기
  const toogleMenu = useCallback(
    (event) => {
      const menuIcon = event.target.closest(`.${styleClasses.menuIcon}`);
      const menuBox = event.target.closest(`.${styleClasses.leftContent}`);

      if (openMenu) {
        if (!menuBox) setOpenMenu(false);
      } else {
        if (menuIcon || menuBox) setOpenMenu(true);
      }
    },
    [openMenu, setOpenMenu]
  );

  // 🔹 메뉴 열기 (스크린 전체 이벤트 추가)
  useEffect(() => {
    document.body.addEventListener("click", toogleMenu);

    return () => {
      document.body.removeEventListener("click", toogleMenu);
    };
  }, [toogleMenu]);

  const fetchMetadata = useCallback(async () => {
    try {
      const genresRef = doc(db, "metadata", "genres");
      const positionsRef = doc(db, "metadata", "positions");

      const genresSnap = await getDoc(genresRef);
      const positionsSnap = await getDoc(positionsRef);

      if (genresSnap.exists()) setGenreOptions(genresSnap.data().list);
      if (positionsSnap.exists()) setPositionOptions(positionsSnap.data().list);
    } catch (error) {
      console.error("메타데이터 불러오기 실패:", error);
    }
  }, []);

  // 🔹 뮤지카드 기본 정보 가져오기 (`musicians/{musicardID}`)
  const fetchMusicard = useCallback(async () => {
    try {
      const musicardRef = doc(db, "musicians", musicardID);
      const musicardSnap = await getDoc(musicardRef);

      if (!musicardSnap.exists()) {
        setError("뮤지카드를 찾을 수 없습니다.");
        setLoading(false);
        return;
      }

      const musicardData = musicardSnap.data();

      // 🔹 스타일 데이터 가져오기 (`musicians/{musicardID}/style/main`)
      const styleRef = doc(db, "musicians", musicardID, "style", "main");
      const styleSnap = await getDoc(styleRef);

      const styleData = styleSnap.exists() ? styleSnap.data() : {};
      setHasStyleData(!!musicardData.name);

      // 🔹 ownerId 검증
      if (musicardData.ownerId !== auth.currentUser.uid) {
        setError("이 뮤지카드를 수정할 권한이 없습니다.");
        setLoading(false);
        return;
      }

      // 🔹 상태 업데이트
      setMusicard(musicardData);
      setFormData({
          name: musicardData.name || musicardID,
          genres: musicardData.genres || [],
          positions: musicardData.positions || [],
          profileImage: musicardData.profileImage || "",
          CDThumbnail: styleData.CDThumbnail || "",
          backgroundColor: styleData.backgroundColor || "",
          fontcolor: styleData.fontcolor || "#FFFFFF",
          font: styleData.font || "", // <-- 기존 font 정보 적용
          dark: styleData.dark || false, // 기존 dark 값 적용
          menuImages: styleData.menuImages || [],
          sns: styleData.sns || {},
          musicLinks: styleData.musicLinks || {}, // <-- 불러오기
          videoId: styleData.videoId || "",
          videoTitle: styleData.videoTitle || "",
          qrimg: styleData.qrimg || ""
      });
      setLoading(false);
    } catch (err) {
      console.error("뮤지카드 로드 오류:", err);
      setError("데이터를 불러오는 중 오류가 발생했습니다.");
      setLoading(false);
    }
  }, [musicardID]);
  
  // 🔹 로그인 확인
  useEffect(() => {
    if (userLoading) return;

    if (user && user.userID) {
      setUserID(user.userID);
    } else  {  
      navigate('/login');
    }
  }, [navigate, user, userLoading]);

  // 🔹 로그인 확인 후 뮤지카드 조회
  useEffect(() => {
    if (!userID) return;

    fetchMetadata();
    fetchMusicard();
  }, [fetchMetadata, fetchMusicard, userID]);
  

  // 🔹 SourceSelector에서 선택한 데이터 처리
  useEffect(() => {
    if (
        !loading &&
        !hasUpdatedSource &&
        location.state &&
        location.state.selectedSource
    ) {
      const { selectedSource } = location.state;
  
      let newImage = "";
      let newLink = "";
      let newTitle = formData.videoTitle; // 기존 값 유지

      newImage = selectedSource.cover || selectedSource.photo || selectedSource.icon || "";
      newLink = selectedSource.url || selectedSource.link || "";
  
      // 🔹 Archive(트랙) 선택한 경우 -> 트랙 제목도 가져오기
      if (selectedSource.title) {
        newTitle = selectedSource.title;
      }
  
      setFormData((prev) => ({
        ...prev,
        videoId: newLink,        // 🔹 배경 음원 YouTube ID
        CDThumbnail: newImage,   // 🔹 CD 썸네일 URL
        videoTitle: newTitle,    // 🔹 배경 음원 제목
      }));
  
      setHasUpdatedSource(true);
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, [loading, location, hasUpdatedSource, formData.videoTitle]);

  // 프리미엄 설정 여부 확인
  useEffect(() => {
    if (musicardID) {
      // customBackgroundByUser에 있는 id와 비교
      const customBackground = customBackgroundByUser.find(
        (custom) => custom.id === musicardID
      );
      if (customBackground) {
        setPopupTitle("프리미엄 설정 안내");
        setPopupText("지금 프리미엄 설정이 적용된 상태입니다. 디자인 변경 시 덮어쓰기될 수 있으며, 복원이 불가하오니 참고해주세요. (프리미엄 설정 해제를 원할 시 하단의 오류보고를 통해 연락해주세요.)");
        setPopupButtonText("확인");
        setCustomFunction(() => () => setOpenPopup(false));
        setOpenPopup(true);
      }
    }
  }, [musicardID]);

  // 🔹 입력값 변경 핸들러
  const handleChange = (e) => {
    if (e.target.name === 'backgroundOptionColor') {
      setFormData({ ...formData, 'backgroundColor': e.target.value });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
      if (e.target.id === 'name') {
        setNameError('');
        setNameErrorText('');
      }
    }
  };

  // 🔹 이미지 팝업 (배경 / 메뉴 이미지)
  const openMusicianGallery = (event) => {
    const element = event.target.closest(`.${CSS.escape(styleClasses.eachImage)}`);
    // index > 0 - 3 : 메뉴 이미지, 4 : 배경 이미지
    if (element) {
      const id = element.id; // 예: "image5" 또는 "image6" 등
      const index = parseInt(id.replace('image', ''));
      if (index === 5) {
        setSelectedImageType("profile");
      } else if (index === 6) {
        setSelectedImageType("cdThumbnail");
      } else {
        setSelectedImageType("menu"); // 또는 index === 4면 배경 이미지 처리
        setImageIndex(index);
      }
    }
    setOpenGalleryPopup(true);
  };

  // 🔹 소스 팝업 - 앨범 선택 (트랙)
  const handleTrackSelect = (newID, newThumbnail, newTitle) => {
    setFormData((prev) => ({
      ...prev,
      videoId: newID || '',             // 🔹 배경 음원 YouTube ID
      CDThumbnail: newThumbnail || '',  // 🔹 CD 썸네일 URL
      videoTitle: newTitle || '',       // 🔹 배경 음원 제목
    }));
    setOpenSourcePopup(false);
  };

  // 🔹 소스 팝업 - 액티비티 선택
  const handleActivitySelect = (activity) => {
    setFormData((prev) => ({
      ...prev,
      videoId: activity.videoId || "",    // 🔹 배경 음원 YouTube ID
      CDThumbnail: activity.photo || '',  // 🔹 CD 썸네일 URL
      videoTitle: activity.title || '',   // 🔹 배경 음원 제목
    }));
    setOpenSourcePopup(false);
  }

  // 🔹 배경 / 메뉴 이미지 선택
  const handleSelectImage = useCallback(async (imageUrl) => {
    if (selectedImageType === "profile") {
      setFormData(prev => ({ ...prev, profileImage: imageUrl }));
    } else if (selectedImageType === "cdThumbnail") {
      setFormData(prev => ({ ...prev, CDThumbnail: imageUrl }));
    } else {
      // 기존 로직: 메뉴 이미지 또는 배경 이미지 업데이트
      if (imageIndex < 4) {
        setFormData(prev => {
          const updated = [...prev.menuImages];
          updated[imageIndex] = imageUrl;
          return { ...prev, menuImages: updated };
        });
      } else if (imageIndex === 4) {
        setFormData(prev => ({ ...prev, backgroundColor: imageUrl })); // 예시 처리
      }
    }
    setOpenGalleryPopup(false);
  }, [imageIndex, selectedImageType]) ;

  // 🔹 배경 / 메뉴 이미지 인덱스 동기화
  useEffect(() => {
    if (imageIndex !== null) {
      setPopupFunction(() => handleSelectImage);
    }
  }, [imageIndex, handleSelectImage]);
    
  // 🔹 메뉴 이미지 초기화 (4개로 고정)
  useEffect(() => {
    let updatedSlots = [...formData.menuImages];

    for (let i = 0 ; i < 4 ; i++) {
      if (!updatedSlots[i]) {
        updatedSlots[i] = '';
      }
    }
  
    setMenuImageSlots(updatedSlots);
  }, [formData.menuImages])

  // 🔹 SNS 변경 핸들러
  const handleSnsChange = (platform, value) => {
    setFormData((prevForm) => ({
      ...prevForm,
      sns: {
        ...prevForm.sns,
        [platform.toLowerCase()]: value, // 소문자로 변환 후 저장
      },
    }));
  };

  // 🔹 SNS 추가 핸들러
  const [newSnsPlatform, setNewSnsPlatform] = useState(""); // 새 SNS 선택 값

  const handleAddSns = () => {
    if (newSnsPlatform.trim() === "" || formData.sns[newSnsPlatform.toLowerCase()]) return;
    setFormData((prevForm) => ({
      ...prevForm,
      sns: { ...prevForm.sns, [newSnsPlatform.toLowerCase()]: "" }, // 빈 값으로 추가
    }));
    setNewSnsPlatform(""); // 입력 필드 초기화
  };
  
  // 🔹 SNS 삭제 핸들러
  const handleRemoveSns = (platform) => {
    setFormData((prevForm) => {
      const updatedSns = { ...prevForm.sns };
      delete updatedSns[platform];
      return { ...prevForm, sns: updatedSns };
    });
  };

  // 🔹 뮤직링크 추가 핸들러
  const [newMusicPlatform, setNewMusicPlatform] = useState("");

  const handleAddMusicPlatform = () => {
    if (newMusicPlatform.trim() === "" || formData.musicLinks[newMusicPlatform.toLowerCase()]) return;
    setFormData((prevForm) => ({
      ...prevForm,
      musicLinks: { ...prevForm.musicLinks, [newMusicPlatform.toLowerCase()]: "" },
    }));
    setNewMusicPlatform("");
  };
  
  const handleRemoveMusicLink = (platform) => {
    setFormData((prevForm) => {
      const updatedMusicLinks = { ...prevForm.musicLinks };
      delete updatedMusicLinks[platform];
      return { ...prevForm, musicLinks: updatedMusicLinks };
    });
  };

  // 🔹 사용 가능한 SNS 목록 (Firestore에서 불러온 데이터 기반)
  const availableSNSPlatforms = ["Instagram", "YouTube", "X", "TikTok", "Facebook", "Thread", "LinkedIn", "Naver Blog", "Kakao Opentalk"];
  const availableMusicPlatforms = ["YouTube Music", "Melon", "Soundcloud", "Spotify", "Flo", "Bugs", "Genie", "Apple Music"];
  
  const currentSnsPlatforms = Object.keys(formData.sns);
  const currentMusicPlatforms = Object.keys(formData.musicLinks);
  const remainingSnsPlatforms = availableSNSPlatforms.filter(
    (sns) => !currentSnsPlatforms.includes(sns.toLowerCase())
  );
  const remainingMusicPlatforms = availableMusicPlatforms.filter(
    (platform) => !currentMusicPlatforms.includes(platform.toLowerCase())
  );

  // URL 유효성 검사 함수
  const validateURL = (url) => {
    try {
      const parsed = new URL(url);
      return parsed.protocol === "http:" || parsed.protocol === "https:";
    } catch (e) {
      return false;
    }
  };

  // 🔹 Firestore 저장 (musicians + users_data)
  const handleSave = async () => {
    if (!musicard) return;
    
    if (formData.name === '') {
      setNameError('error');
      setNameErrorText('뮤지션 이름을 입력하세요.');
      nameRef.current.focus();
      return false;
    } else if (formData.positions.length === 0 && !formData.positions?.includes('Group/Band')) {
      setOpenPopup(true);
      setPopupTitle("포지션을 선택해주세요.");
      setPopupButtonText('');
      setCustomFunction('');
      return false;
    } else if (formData.genres.length === 0) {
      setOpenPopup(true);
      setPopupTitle("장르를 선택해주세요.");
      setPopupButtonText('');
      setCustomFunction('');
      return false;
    }

    // 추가: SNS 링크 유효성 검사
    for (let platform in formData.sns) {
      const link = formData.sns[platform];
      if (!link || !validateURL(link)) {
        setOpenPopup(true);
        setPopupTitle(`${platform} 링크 오류`);
        setPopupText(`"${platform}"의 링크 값이 비어있거나 올바른 URL 형식이 아닙니다.`);
        setPopupButtonText('');
        return;
      }
    }
    
    // 추가: 뮤직 링크 유효성 검사
    for (let platform in formData.musicLinks) {
      const link = formData.musicLinks[platform];
      if (!link || !validateURL(link)) {
        setOpenPopup(true);
        setPopupTitle(`${platform} 링크 오류`);
        setPopupText(`"${platform}"의 링크 값이 비어있거나 올바른 URL 형식이 아닙니다.`);
        setPopupButtonText('');
        return;
      }
    }

    try {
      if (isSubmitting.current) return; // 실행 중일 경우 중복 클릭 방지
      isSubmitting.current = true;      // 버튼 비활성화
      setButtonLoading(true);           // 버튼 로딩 표시
      
      // 🔹 Firestore에서 현재 뮤지카드의 ownerId 가져오기
      const musicardRef = doc(db, "musicians", musicardID);
      const musicardSnap = await getDoc(musicardRef);
  
      if (!musicardSnap.exists()) {
        isSubmitting.current = false;   // 버튼 활성화
        setButtonLoading(false);        // 버튼 로딩 숨김
        
        setOpenPopup(true);
        setPopupTitle('뮤지카드를 찾을 수 없습니다.');
        setPopupButtonText('');
        setCustomFunction('');

        return;
      }
  
      const musicardData = musicardSnap.data();
  
      // 🔹 ownerId 검증 (현재 로그인한 사용자와 비교)
      if (musicardData.ownerId !== auth.currentUser.uid) {
        isSubmitting.current = false;   // 버튼 활성화
        setButtonLoading(false);        // 버튼 로딩 숨김
        
        setOpenPopup(true);
        setPopupTitle('이 뮤지카드를 수정할 권한이 없습니다.');
        setPopupButtonText('');
        setCustomFunction('');
        return;
      }
  
      // 🔹 뮤지카드 기본 정보 업데이트
      await updateDoc(musicardRef, {
        name: formData.name,
        genres: formData.genres,
        positions: formData.positions,
        profileImage: formData.profileImage,
      });
  
      // 🔹 스타일 정보 저장 (`musicians/{musicardID}/style/main`)
      const styleRef = doc(db, "musicians", musicardID, "style", "main");
  
      // 🔹 저장할 스타일 데이터
      const styleDoc = {
        CDThumbnail: formData.CDThumbnail ?? "",
        backgroundColor: formData.backgroundColor ?? "#FFFFFF",
        fontcolor: formData.fontcolor ?? "#000000",
        font: formData.font ?? "",  // 선택된 폰트 URL 저장
        dark: formData.dark,  // 추가: 체크박스에 따라 어둡게 선택되었는지 여부
        menuImages: formData.menuImages ?? [],
        sns: formData.sns ?? {},
        musicLinks: formData.musicLinks ?? {}, // <-- 추가
        videoId: formData.videoId ?? "",
        videoTitle: formData.videoTitle ?? "",
        qrimg: formData.qrimg ?? ""
      };
  
      await setDoc(styleRef, styleDoc);

      const changedPaths = [musicardRef.path, styleRef.path];
      await saveUserLog('musicard_logs', musicardID, 'update', changedPaths, 'MusicardEditPage');
  
      // alert("뮤지카드가 성공적으로 업데이트되었습니다!");
      isSubmitting.current = false;   // 버튼 활성화
      setButtonLoading(false);        // 버튼 로딩 숨김

      setOpenPopup(true);
      setPopupTitle('뮤지카드가 성공적으로 업데이트되었습니다!');
      setPopupButtonText('목록으로 이동');
      setCustomFunction(() => () => navigate("/my-page/musicard"));
    } catch (error) {
      isSubmitting.current = false;   // 버튼 활성화
      setButtonLoading(false);
      console.error("뮤지카드 업데이트 오류:", error);
      
      setOpenPopup(true);
      setPopupTitle("뮤지카드 업데이트 중 오류가 발생했습니다.");
      setPopupButtonText('');
      setCustomFunction('');
    }
  };  

  // YouTube URL에서 영상 ID 추출 함수
  const extractYouTubeVideoID = (url) => {
    const regExp = /(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|v\/))([a-zA-Z0-9_-]{11})/;
    const match = url.match(regExp);
    return match ? match[1] : url;
  };
  
  if (error) return <p className={styleClasses.error}>{error}</p>;

  return (
    <>
      <SEO title='뮤지카드 수정' />
      <div className={ styleClasses.myPageMobile }>
        <div className={ styleClasses.inner }>
          <div className={ styleClasses.title }>
            <h1>My Musicard</h1>
            <button className={ styleClasses.menuIcon }>
              <div className="commonIcon mobile">
                <i className={`${ openMenu ? 'upWhite' : 'downWhite' } w24`}></i>
              </div>
            </button>
          </div>
          <div className={ styleClasses.editContent }>
            <div className={`${ styleClasses.leftContent } ${ openMenu ? styleClasses.open : '' }`}>
              <MyPageMenu currentPage='musicard' />
            </div>
            <div className={ styleClasses.rightContent }>
              <div className={ styleClasses.content }>
                <div className={styleClasses.editPage}>
                  {
                    loading
                    ?
                    <Loading />
                    :
                    <div className="commonForm">
                    {/* 그룹 A: styleData가 없을 때만 보여줌 */}
                    { !hasStyleData && (
                      <>
                      <div className="formRow fullWidth">
                        <div className="labelBox">
                          <label>뮤지션 이름</label>
                          <div className={`commonIcon toolTip ${ styleClasses.topButtonToolTip }`}>
                            <i className="questionBlack w20"></i>
                            <div className="toolTipText bottom">
                              <p>뮤지카드에 표시될 활동명 입니다.</p>
                            </div>
                          </div>
                        </div>
                        <div className={`fieldBox ${ nameError }`}>
                          <input type="text" name="name" id="name" value={formData.name || musicardID} ref={ nameRef } onChange={ handleChange } />
                          <div className="fieldError">
                            <p>{ nameErrorText }</p>
                          </div>
                        </div>
                      </div>
                      <CheckBoxSelector
                        label="장르 선택"
                        options={genreOptions}
                        selectedItems={formData.genres}
                        setSelectedItems={(newItems) => setFormData((prev) => ({ ...prev, genres: newItems })) }
                        styleClasses={styleClasses}
                      />
                      {!formData.positions.includes("Group/Band") && (
                      <CheckBoxSelector
                        label="포지션 선택"
                        options={positionOptions}
                        selectedItems={formData.positions}
                        setSelectedItems={(newItems) => setFormData((prev) => ({ ...prev, positions: newItems })) }
                        styleClasses={styleClasses}
                      />
                      )}
                      <div className="formRow fullWidth">
                        <div className="labelBox">
                          <label htmlFor="profileImage">프로필 이미지 URL</label>
                        </div>
                        <div className={`fieldBox ${ styleClasses.withButton }`}>
                          <input type="text" name="profileImage" id="profileImage" value={formData.profileImage} onChange={handleChange} />
                        </div>
                        <div className="commonButton fullWidth">
                          <button className={ styleClasses.eachImage } id="image5" onClick={ (event) => openMusicianGallery(event) }>
                          프로필 이미지 업로드
                          </button>
                        </div>
                      </div>
                      </>
                    )}

                    {/* 그룹 B: styleData가 있을 때만 보여줌 */}
                    { hasStyleData && (
                      <>
                      <div className="formRow fullWidth">
                        <div className="labelBox">
                          <label>뮤지카드 디자인</label>
                        </div>
                        <div className="fieldBox">
                        <div className={ styleClasses.previewSection } style={ formData.backgroundColor ? { background: formData.backgroundColor } : {background: '#0C0C12'} }>
                          <div className={ styleClasses.inner }>
                            <div className={ styleClasses.leftMenu }>
                            {
                              menuImageSlots.map((image, index) => (
                                <div key={ index } className={ styleClasses.eachImage } id={`image${ index }`} onClick={ (event) => openMusicianGallery(event) }>
                                  <div className={ styleClasses.imageBox }>
                                    <div className={ styleClasses.emptyBox } style={ image !== '' ? { backgroundImage: `url("${ image }")` } : { backgroundImage: `url("/assets/images/Background Test 1.png")` } } />
                                    <div className={`commonIcon ${ styleClasses.innerIcon }`}>
                                      <i className="pencilBlack w24"></i>
                                    </div>
                                  </div>
                                </div>
                              ))
                            }
                            </div>
                            <div className={ styleClasses.rightMenu }>
                              <div className={ styleClasses.fontView }>
                                {/* 폰트 테스트 미리보기 영역 */}
                                {
                                  formData.font && (
                                  <style>
                                    {`
                                      @font-face {
                                        font-family: 'CustomPreviewFont';
                                        src: url(${formData.font});
                                      }
                                    `}
                                  </style>
                                )}
                                <p className={ styleClasses.fontPreview }
                                  style={{
                                    color: formData.fontcolor,
                                    fontFamily: formData.font ? 'CustomPreviewFont' : 'inherit',
                                  }}
                                >
                                  {formData.name || "이름 없음"}
                                </p>
                                <input
                                  type="color"
                                  id="fontcolor"
                                  name="fontcolor"
                                  value={formData.fontcolor}
                                  onChange={(e) => setFormData({ ...formData, fontcolor: e.target.value })}
                                  style={{ minWidth: '35px', flexShrink: 0 }}
                                />
                              </div>
                              <div className="fieldBox" style={{zIndex: 2, maxWidth: '55%'}}>
                                <Select
                                  id="fontSelect"
                                  options={options}
                                  styles={customStyles}
                                  placeholder="기본 폰트 선택"
                                  onChange={(selectedOption) =>
                                    setFormData({ ...formData, font: selectedOption.value })
                                  }
                                  value={options.find(option => option.value === formData.font)}
                                />
                              </div>
                              <div className={ styleClasses.buttons }>
                                <div className="commonButton fullWidth">
                                  <input type="color" name="backgroundOptionColor" ref={ colorInput } onChange={ handleChange } />
                                  <input style={{ display: 'none' }} type="text" name="backgroundColor" id="backgroundColor" value={ formData.backgroundColor } onChange={ handleChange } />
                                  <button onClick={ () => colorInput.current.click() }>
                                    배경색 선택
                                  </button>
                                </div>
                                <div className="commonButton fullWidth">
                                  <button className={ styleClasses.eachImage } id="image4" onClick={ (event) => openMusicianGallery(event) }>
                                    배경 이미지 선택
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        </div>
                      </div>
                      <div className={ styleClasses.cdPlayerOptions }>
                        <button className={ styleClasses.eachImage } id="image6" onClick={ (event) => openMusicianGallery(event) }>
                          <div className={ styleClasses.cdWrap }>
                            <div className={ styleClasses.cdDisplay }>
                              <div className={ styleClasses.cd }>
                                <div 
                                  className={ styleClasses.cdBackground }
                                  style={{ 
                                    backgroundImage: `url(${ formData.CDThumbnail ? formData.CDThumbnail : (formData.videoId ? `https://img.youtube.com/vi/${formData.videoId}/0.jpg` : `https://img.youtube.com/vi/q3gKI9o8QhM/0.jpg`) })` 
                                  }}
                                ></div>
                                <div className={ styleClasses.centerLabel }>
                                </div>
                              </div>
                            </div>
                          </div>
                        </button>
                        <div className="formRow fullWidth">
                          <div className="labelBox">
                            <label htmlFor="videoId">배경 음원 YouTube URL</label>
                          </div>
                          <div className="fieldBox">
                            <input
                              type="text"
                              name="videoId"
                              id="videoId"
                              value={formData.videoId}
                              placeholder={formData.videoId ? "" : "URL 입력하면 자동으로 영상ID 값만 추출하여 저장"}
                              onChange={(e) => {
                                const inputValue = e.target.value;
                                // 입력된 값이 있으면 videoId를 추출해서 저장, 없으면 빈 문자열로 설정
                                const extractedVideoId = inputValue ? extractYouTubeVideoID(inputValue) : "";
                                setFormData({ ...formData, videoId: extractedVideoId });
                              }}
                            />
                          </div>
                          <div className="labelBox">
                            <label htmlFor="videoId">배경 음원 제목<br></br>미입력 시, YouTube 영상 제목으로 자동 설정</label>
                          </div>
                          <div className="fieldBox">
                            <input
                              type="text"
                              name="videoId"
                              id="videoId"
                              value={formData.videoTitle}
                              onChange={(e) => setFormData({ ...formData, videoTitle: e.target.value })}
                            />
                          </div>
                        </div>
                        <div className="commonButton fullWidth">
                          <div className={`commonIcon toolTip mobile ${ styleClasses.topButtonToolTip }`}>
                            <i className="questionBlack w16"></i>
                            <div className="toolTipText">
                              <p>이미 저장한 음원(Archive) 및 활동(Activity) 데이터에서 <br />이미지 및 링크 정보를 가져올 수 있습니다.</p>
                            </div>
                          </div>
                          {/* navigate(`/my-page/musicard/${musicardID}/source-selector`, { state: {} }) */}
                          <button type="button" onClick={() => setOpenSourcePopup(true) }>Archive·Activity에서 가져오기</button>
                        </div>
                      </div>
                      <div className="formRow fullWidth">
                        <div className="labelBox">
                          <label>SNS 및 스트리밍 사이트 연결</label>
                        </div>
                        {/* 아이콘 색 체크박스 추가 */}
                        <div className="fieldBox">
                          <div className={ styleClasses.snsGroup }>
                          <div className={ styleClasses.snsInputRow }>
                            <div className={`labelBox ${ styleClasses.customLabelBox }`}>
                              <label>아이콘 색</label>
                              </div>
                              <div className={`fieldBox checkBox ${ styleClasses.customFieldBox }`}>
                                <div className="eachBox">
                                  <input type="checkbox" id="iconDark" checked={formData.dark} onChange={(e) => setFormData({ ...formData, dark: e.target.checked })} />
                                  <label htmlFor="iconDark">어둡게</label>
                                </div>
                            </div>
                          </div>
                          {/* 🔹 기존 뮤직링크 데이터 표시 */}
                          {currentMusicPlatforms.map((platform) => (
                          <div key={platform} className={ styleClasses.snsInputRow }>
                            <div className={`labelBox ${ styleClasses.customLabelBox }`}>
                              <label>{platform.charAt(0).toUpperCase() + platform.slice(1)}</label>
                            </div>
                            <div className={`fieldBox ${ styleClasses.customFieldBox }`}>
                              <input
                              type="text"
                              name={platform}
                              value={formData.musicLinks[platform] || ""}
                              placeholder={`Enter ${platform} URL`}
                              onChange={(e) =>
                                  setFormData((prevForm) => ({
                                  ...prevForm,
                                  musicLinks: { ...prevForm.musicLinks, [platform]: e.target.value },
                                  }))
                              }
                              />
                            </div>
                            <div className={`buttonBox ${ styleClasses.customButtonBox }`}>
                              <div className="commonButton fullWidth">
                              <button type="button" className="secondary" onClick={() => handleRemoveMusicLink(platform)}>삭제</button>
                              </div>
                            </div>
                          </div>
                          ))}
                          <div className={styleClasses.addSnsRow}>
                            <div className={`labelBox ${ styleClasses.customLabelBox }`}>
                              <label htmlFor="">뮤직 링크 선택</label>
                            </div>
                            <div className={`fieldBox ${ styleClasses.customFieldBox }`}>
                              <select value={newMusicPlatform} onChange={(e) => setNewMusicPlatform(e.target.value)}>
                                  <option value="">스트리밍 플랫폼</option>
                                  {remainingMusicPlatforms.map((platform) => (
                                  <option key={platform} value={platform}>{platform}</option>
                                  ))}
                              </select>
                            </div>
                              <div className={`buttonBox ${ styleClasses.customButtonBox }`}>
                                <div className="commonButton fullWidth">
                                  <button type="button" onClick={handleAddMusicPlatform}>추가</button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className={ styleClasses.snsGroup }>
                            {/* 🔹 기존 SNS 데이터 표시 */}
                            {currentSnsPlatforms.map((snsPlatform) => (
                              <div key={snsPlatform} className={ styleClasses.snsInputRow }>
                                <div className={`labelBox ${ styleClasses.customLabelBox }`}>
                                  <label>{snsPlatform.charAt(0).toUpperCase() + snsPlatform.slice(1)}</label>
                                </div>
                                <div className={`fieldBox ${ styleClasses.customFieldBox }`}>
                                  <input
                                    type="text"
                                    name={snsPlatform}
                                    value={formData.sns[snsPlatform] || ""}
                                    placeholder={`Enter ${snsPlatform} URL`}
                                    onChange={(e) => handleSnsChange(snsPlatform, e.target.value)}
                                  />
                                </div>
                                <div className={`buttonBox ${ styleClasses.customButtonBox }`}>
                                  <div className="commonButton fullWidth">
                                    <button type="button" className="secondary" onClick={() => handleRemoveSns(snsPlatform)}>삭제</button>
                                  </div>
                                </div>
                              </div>
                            ))}
                            {/* 🔹 새로운 SNS 추가 */}
                            <div className={styleClasses.addSnsRow}>
                              <div className={`labelBox ${ styleClasses.customLabelBox }`}>
                                <label htmlFor="">SNS 링크 선택</label>
                              </div>
                              <div className={`fieldBox ${ styleClasses.customFieldBox }`}>
                                <select value={newSnsPlatform} onChange={(e) => setNewSnsPlatform(e.target.value)}>
                                  <option value="">SNS 플랫폼</option>
                                  {
                                    remainingSnsPlatforms.map((sns) => (
                                      <option key={ sns } value={ sns }>{ sns }</option>
                                    ))
                                  }
                                </select>
                              </div>
                              <div className={`buttonBox ${ styleClasses.customButtonBox }`}>
                                <div className="commonButton fullWidth">
                                  <button type="button" onClick={handleAddSns}>추가</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      </>
                    )}
                      <div className={ styleClasses.formButtons }>
                        <div className="commonButton">
                          <Link to='/my-page/musicard' className="secondary">목록으로 이동</Link>
                        </div>
                        <div className="commonButton fullWidth">
                          <button className="black" onClick={ handleSave }>
                            저장하기
                            <div className={`buttonLoading ${ buttonLoading ? 'active' : undefined }`}>
                              <div></div>
                              <div></div>
                              <div></div>
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <MusicianGalleryPopup
        uid={ userID }
        open={ openGalleryPopup }
        setOpenPopup={ setOpenGalleryPopup }
        imageIndex={ imageIndex }
        buttonFunction={ popupFunction }
        onSelectImage={handleSelectImage}  // 선택된 이미지 URL을 처리하는 콜백
      />
      <MusicardSourcePopup
        open={ openSourcePopup }
        setOpenPopup={ setOpenSourcePopup }
        handleTrackSelect={ handleTrackSelect }
        handleActivitySelect={ handleActivitySelect }
      />
      <Popup
        open={ openPopup }
        setOpenPopup={ setOpenPopup }
        title={ popupTitle }
        text={ popupText }
        buttonText={ popupButtonText }
        buttonFunction={ customFunction } />
    </>
  );
}

export default MusicardEditPage;